<template>
  <div class="grid">
    <div class="col-12">
      <Card>
        <template #title>Повторная отправка событий</template>
        <template #content>
          <ResendEventsForm
              ref="resendEventsForm"
              commit-label="Отправить события"
              commit-icon="pi pi-send"
          />
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import ResendEventsForm from "@/components/Forms/ResendEventsForm.vue";

export default {
  name: 'ResendEvents',
  components: {
    ResendEventsForm
  },
  methods: {

  }
}
</script>